<template>
  <div style="padding-top: 10px;" name="online-form">
    <span v-if="html">
      <template-dynamic-view
        :templateKey="templateKey"
        :html="html"
        :taskType="taskType"
        :single="single"
        :dataView="dataView"
        :isJoinFlow="isJoinFlow"
        :parameterqQuerys="parameterqQuerys"
        :templateInfo="templateInfo"
      />
    </span>
    <div class="loaded-fail__div" v-if="loadedFail">报表不存在...</div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Message } from "element-ui";
import { Loading } from "element-ui";
import EcoCheckbox from "@/components/control/FeCheckbox.vue";
import EcoDialog from "@/components/control/FeDialog.vue";
import TemplateDynamicView from "@/components/dataTemplate/TemplateDynamicView.vue";
import EcoDialogBtn from "@/components/control/FeDialogBtn.vue";
import VRuntimeTemplate from "v-runtime-template";
import utils from "@/utils.js";
import { Base64 } from "js-base64";

export default {
  name: "templatePreview",
  props: {
    templateKey: String,
    parameterqQuerys: String,
    single: String,
    taskType: {
      default: ""
    },
    defKey: String,
    dataView: Object,
    isJoinFlow: {
      default: false
    }
  },
  data() {
    return {
      html: "",
      templateInfo: {},
      tableData: { selectRows: [], querys: "" },
      dialogExportVisible: false,
      exportData: { getType: "all", expField: [] },
      displayFields: [],
      exportSellection: [],
      searchForm: { F_xb: "", F_xm: "" },
      queryForm: {
        queryData: ""
      },
      formType: false,
      labelPosition: "left",
      incons: "el-icon-arrow-down",
      options: {
        fullscreen: true,
        lock: true
      },
      loadedFail: false
    };
  },
  computed: {
    ...mapState({
      rows: state => state.form.bpmTemplateRows,
      pagination: state => state.form.bpmTemplatePagination,
      total: state => state.form.bpmTemplateTotal,
      dialogSubVisible: state => state.form.bpmTemplateSubData.dialogSubVisible,
      tabs: state => state.form.bpmTemplateSubData.tabs,
      ents: state => state.form.bpmTemplateSubData.ents,
      refId: state => state.form.bpmTemplateSubData.refId
    })
  },
  components: {
    VRuntimeTemplate,
    EcoCheckbox,
    EcoDialog,
    EcoDialogBtn,
    TemplateDynamicView
  },
  watch: {
    templateKey: function(newVal) {
      if (newVal) {
        this.init();
      }
    },
    ents: {
      handler: function(newVal, oldValue) {
        // if(newVal && newVal.length>=1 && newVal != oldValue ){
        //   this.getSubData(this,this.refId);
        // }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.init();
  },
  methods: {
    // 根据当前formKey初始化
    init() {
      const loading = this.$loading(this.options);
      let _me = this;
      this.$store
        .dispatch("form/getBpmDataTemplateInfo", {
          templateKey: this.templateKey
        })
        .then(result => {
          if (result.state) {
            _me.templateInfo = result.value;
            if (_me.templateInfo.displayField) {
              let displayField = utils.parseToJson(
                _me.templateInfo.displayField
              );
              for (var i = 0; i < displayField.length; i++) {
                if (displayField[i].type) {
                  this.displayFields.push(displayField[i]);
                }
              }
            }
            if (_me.templateInfo.conditionField) {
              let conditionField = utils.parseToJson(
                _me.templateInfo.conditionField
              );
              for (var i = 0; i < conditionField.length; i++) {
                var fieldName = "F_" + conditionField[i].name;
                this.$set(this.searchForm, fieldName, "");
              }
            }
            let params = { templateId: _me.templateInfo.id };
            let pageBean = {
              pageBean: {
                page: "1",
                pageSize: result.value.pageSize,
                showTotal: "true"
              }
            }; //初次加载默认pageBean
            params.pagination = pageBean;
            if (_me.isJoinFlow) {
              params.isJoinFlow = true;
              params.taskType = _me.taskType;
              params.defKey = _me.defKey;
            }
            if (_me.dataView) {
              //关联查询字段
              if (_me.dataView.bindSelectd && _me.dataView.bindSelectd != "") {
                const pInst = utils.getOnlineFormInstance(this.$parent);
                const path =
                  "data." +
                  _me.dataView.boDefAlias +
                  "." +
                  _me.dataView.selectField;
                const value = utils.getValueByPath(pInst, path);
                _me.dataView.selectValue = value;
                params.selectField = _me.dataView.bindSelectd;
                params.selectValue = _me.dataView.selectValue;
              }
            }
            if (this.parameterqQuerys) {
              var querys = JSON.parse(
                Base64.decode(decodeURIComponent(this.parameterqQuerys))
              );
              params.pagination.querys = querys;
            }
            this.$store
              .dispatch("form/getBpmTemplateByPagination", params)
              .then(() => {
                loading.close();
              });
            let treeField = JSON.parse(_me.templateInfo.treeField);
          }
        });
      this.$store
        .dispatch("form/getTemplateDataListForm", this.templateKey)
        .then(result => {
          if (result.state) {
            _me.html = result.value;
          } else {
            this.loadedFail = true;
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    handleSizeChange: function(size) {
      //每页下拉显示数据
      this.$store.dispatch("form/setBpmTemplatePaginationSize", size);
      this.search();
    },
    handleCurrentChange: function(currentPage) {
      //点击第几页
      this.$store.dispatch("form/setBpmTemplatePaginationPageNum", currentPage);
      this.search();
    },
    search(str) {
      const loading = this.$loading(this.options);
      let params = {};
      if (str == "find") {
        this.$store.dispatch("form/setBpmTemplatePaginationPageNum", 1);
      }
      //判断为合并查询还是分开查询
      if (this.formType) {
        params = this.getQueryFilter();
      } else {
        //判断是否配置了合并查询
        if ($(".search-query").length > 0) {
          params = this.getConditionQuery();
        } else {
          params = this.getQueryFilter();
        }
      }
      if (params.pagination && params.pagination && params.pagination.querys) {
        let tempQueryS = [];
        let betweenConditions = {};
        params.pagination.querys.forEach(q => {
          if (
            q.value &&
            (q.operation != "BETWEEN" || q.value.constructor == Array)
          ) {
            tempQueryS.push(q);
          } else if (q.value) {
            let conditions = q;
            if (betweenConditions[q.property]) {
              conditions = betweenConditions[q.property];
              conditions.value = [conditions.value];
              conditions.value.push(q.value);
            }
            betweenConditions[q.property] = conditions;
          }
        });
        for (const key in betweenConditions) {
          tempQueryS.push(betweenConditions[key]);
        }
        params.pagination.querys = tempQueryS;
      }
      if (this.isJoinFlow) {
        params.isJoinFlow = true;
        params.taskType = this.taskType;
        params.defKey = this.defKey;
      }
      if ($.isEmptyObject(this.searchForm)) {
        this.$store
          .dispatch("form/getBpmTemplateByPagination", params)
          .then(() => {
            loading.close();
          });
      } else {
        this.$store
          .dispatch("form/getBpmTemplateByPagination", params)
          .then(() => {
            loading.close();
          });
      }
    },
    getQueryFilter() {
      let operationMap = this.getSearchItems();
      let querys = []; //查询条件
      let queryFilter = {};
      let pageBean = { pageBean: this.pagination };
      let params = { templateId: this.templateInfo.id };
      params.pagination = pageBean;
      if ($.isEmptyObject(this.searchForm)) {
        return params;
      } else {
        for (var key in this.searchForm) {
          if (
            typeof this.searchForm[key] != "undefined" &&
            this.searchForm[key] != ""
          ) {
            if (this.searchForm[key] instanceof Array) {
              for (var i = 0; i < this.searchForm[key].length; i++) {
                querys.push({
                  property: key,
                  value: this.searchForm[key][i],
                  group: "main",
                  operation: operationMap[key],
                  relation: "AND"
                });
              }
            } else {
              querys.push({
                property: key,
                value: this.searchForm[key],
                group: "main",
                operation: operationMap[key],
                relation: "AND"
              });
            }
          }
        }
        queryFilter = { pageBean: this.pagination, querys };
        params.pagination = queryFilter;
        return params;
      }
    },
    getSearchItems() {
      let searchItems = $(".search-item");
      let operationMap = {};
      let operationType = {
        like: "LIKE",
        equal: "EQUAL",
        between: "BETWEEN",
        left_like: "LEFT_LIKE",
        right_like: "RIGHT_LIKE"
      };
      if (searchItems) {
        for (var i = 0; i < searchItems.length; i++) {
          var operation = "=";
          if (typeof $(searchItems[i]).attr("eco-query") != "undefined") {
            operation = $(searchItems[i]).attr("operation");
            operationMap[$(searchItems[i]).attr("eco-query")] =
              typeof operationType[operation] != "undefined"
                ? operationType[operation]
                : operation;
          } else if (
            typeof $(searchItems[i])
              .children()
              .attr("eco-query") != "undefined"
          ) {
            operation = $(searchItems[i])
              .children()
              .attr("operation");
            operationMap[
              $(searchItems[i])
                .children()
                .attr("eco-query")
            ] =
              typeof operationType[operation] != "undefined"
                ? operationType[operation]
                : operation;
          }
        }
      }
      return operationMap;
    },
    getConditionQuery() {
      let searchAll = $(".search-query");
      let values = "";
      let querys = []; //查询条件
      let queryFilter = {};
      let pageBean = { pageBean: this.pagination };
      let params = { templateId: this.templateInfo.id };
      params.pagination = pageBean;
      if (this.queryForm.queryData == "") {
        return params;
      } else {
        if (
          typeof $($(searchAll[0]).children()[0]).attr("eco-quick-search") !=
          "undefined"
        ) {
          values = $($(searchAll[0]).children()[0]).attr("eco-quick-search");
          var arr = values.split(",");
          for (let value of arr) {
            querys.push({
              property: value,
              value: this.queryForm.queryData,
              group: "main",
              operation: "LIKE",
              relation: "OR"
            });
          }
        }
      }
      queryFilter = { pageBean: this.pagination, querys };
      params.pagination = queryFilter;
      return params;
    },
    //打开高级检索
    advanced() {
      this.formType = !this.formType;
      if (this.formType) {
        this.incons = "el-icon-arrow-up";
        this.queryForm.queryData = "";
      } else {
        this.incons = "el-icon-arrow-down";
        this.searchForm = {};
      }
    },
    //回车查询
    searchEnterFun: function(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.search();
      }
    },
    reset() {
      this.queryForm.queryData = "";
      if (this.templateInfo.conditionField) {
        let conditionField = utils.parseToJson(
          this.templateInfo.conditionField
        );
        for (var i = 0; i < conditionField.length; i++) {
          var fieldName = "F_" + conditionField[i].name;
          this.$set(this.searchForm, fieldName, "");
        }
      }
      this.search();
    },
    handleSelectionChange(val) {
      this.tableData.selectRows = val;
    },
    deleted() {
      if (
        this.tableData.selectRows == null ||
        this.tableData.selectRows.length == 0
      ) {
        this.$message.warning("请选择文件删除!");
        return false;
      }
      this.$confirm("此操作将删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var s = "";
          for (var i = 0; i < this.tableData.selectRows.length; i++) {
            s +=
              s + this.tableData.selectRows[i][this.templateInfo.pkField] + ",";
          }
          s = s.substring(0, s.length - 1);
          let data = { ids: s, boAlias: this.templateInfo.boDefAlias };
          this.$store.dispatch("form/deleteTemplateDataById", data).then(() => {
            this.search();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    del(id) {
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let data = { ids: id, boAlias: this.templateInfo.boDefAlias };
          this.$store.dispatch("form/deleteTemplateDataById", data).then(() => {
            this.search();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    startFlow(id) {
      let data = {
        defKey: this.templateInfo.defId,
        businessKey: id,
        boAlias: this.templateInfo.boDefAlias
      };
      let loadingInstance = Loading.service({ fullscreen: true }); //开始
      this.$store.dispatch("storeProcess/startForm", data).then(result => {
        loadingInstance.close(); // 结束
        if (result.state) {
          this.$message.success(result.message);
          this.search();
        } else {
          this.disabled = false;
          this.$message.error(result.message);
        }
      });
    },
    //点击导出按钮
    exports() {
      this.dialogExportVisible = true;
    },

    //显示子表对话框
    showSubList(refId) {
      this.$store.dispatch("form/actionsBpmTemplateSubData", {
        dialogSubVisible: false,
        tabs: [],
        ents: []
      });
      this.getSubEntsByFormKey(refId);
    },

    //确定导出
    submitExport() {
      if (!this.exportData || this.exportData.expField.length < 1) {
        this.$message({
          type: "info",
          message: "请选择要导出的字段！"
        });
        return;
      }
      let expField = "";
      for (var i = 0; i < this.exportData.expField.length; i++) {
        if (i > 0) {
          expField += ",";
        }
        expField += this.exportData.expField[i].name;
      }
      expField = Base64.encode(expField);
      let data = {
        boAlias: this.templateInfo.alias,
        getType: this.exportData.getType,
        expField: expField,
        filterKey: ""
      };
      data.query = this.getQueryFilter().pagination;
      let loadingInstance = Loading.service({ fullscreen: true }); //开始
      this.$store.dispatch("form/templateExport", data).then(() => {
        loadingInstance.close(); // 结束
        this.dialogExportVisible = false;
      });
    },

    //取消导出
    exportCancel() {
      this.dialogExportVisible = false;
      this.exportData.expField = [];
    },

    //取消子表对话框
    subCancel() {
      this.$store.dispatch("form/actionsBpmTemplateSubData", {
        dialogSubVisible: false,
        tabs: [],
        ents: []
      });
    },

    handleExportSelectionChange(val) {
      this.exportData.expField = [];
      if (val) {
        this.exportData.expField = val;
      }
    },

    //全选
    handleExportSelectAll() {
      this.exportData.expField = this.displayFields;
    },

    //排序
    sort(index, type) {
      if ("up" == type) {
        if (index === 0) {
          this.$message({
            message: "已经是列表中第一位",
            type: "warning"
          });
        } else {
          let temp = this.displayFields[index - 1];
          this.$set(this.displayFields, index - 1, this.displayFields[index]);
          this.$set(this.displayFields, index, temp);
        }
      } else {
        if (index === this.displayFields.length - 1) {
          this.$message({
            message: "已经是列表中最后一位",
            type: "warning"
          });
        } else {
          this.isTransition = true;
          let i = this.displayFields[index + 1];
          this.$set(this.displayFields, index + 1, this.displayFields[index]);
          this.$set(this.displayFields, index, i);
        }
      }
    },

    getSubEntsByFormKey(refId) {
      let _me = this;
      this.$store.dispatch("form/actionsBpmTemplateSubData", {
        dialogSubVisible: false,
        tabs: [],
        ents: []
      });
      if (!_me.ents || _me.ents.length < 1) {
        this.$store
          .dispatch("form/getSubEntsByFormKey", this.templateInfo.formKey)
          .then(ents => {
            this.$store.dispatch("form/actionsBpmTemplateSubData", {
              dialogSubVisible: false,
              tabs: [],
              ents: ents,
              refId: refId
            });
          });
      } else {
        this.getSubData(_me, refId);
      }
    },

    getSubData(_me, refId, oldTabs) {
      let ents = _me.ents;
      let tabs = oldTabs ? oldTabs : [];
      if (ents && ents.length > 0) {
        for (var i = 0; i < ents.length; i++) {
          var attributeList = ents[i].attributeList;
          var tab = {
            name: ents[i].tableName,
            title: ents[i].comment,
            attributeList: attributeList,
            comment: ents[i].comment,
            pagination: {
              pageBean: {
                pageSize: 10,
                page: 1,
                total: 0
              }
            }
          };

          this.$store
            .dispatch("form/getSubDataPagination", {
              pagination: tab.pagination,
              name: ents[i].name,
              refId: refId
            })
            .then(data => {
              if (data && data.rows.length > 0) {
                tab.dataList = data.rows;
                tab.pagination.pageBean.pageSize = data.pageSize;
                tab.pagination.pageBean.page = data.page;
                tab.pagination.pageBean.total = data.total;
              } else {
                tab.dataList = [];
                tab.pagination.pageBean.pageSize = 0;
                tab.pagination.pageBean.page = 1;
                tab.pagination.pageBean.total = 0;
              }
              tabs.push(tab);
              this.$store.dispatch("form/actionsBpmTemplateSubData", {
                dialogSubVisible: true,
                tabs: tabs,
                ents: []
              });
            });
        }
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
>>> th.todo-header-row {
  background-color: #fafafa;
  font-size: 13px;
}

>>> tr.todo-row {
  font-size: 13px;
  color: #000;
}

.el-container {
  background-color: #fff;
}

.el-row {
  margin-bottom: 20px;
}

.el-header {
  border-bottom: 1.5px solid #ededed;
}

.i {
  margin-right: 4px;
}

.todo-subject {
  cursor: pointer;
}

.todo-subject:hover {
  color: #2761ff;
}

>>> .el-dialog__body {
  padding: 15px 10px;
}

>>> .el-checkbox {
  margin-left: 15px;
}

>>> .el-radio {
  margin-left: 15px;
}

>>> .el-button{
  margin-left: 0px;
}
.loaded-fail__div {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #f56c6c;
}
</style>
